import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect, useState } from 'react';
// import { Search } from 'lucide-react';
import { Button } from '../../Common/Button';
import AddBulkAgents from '../../Commponent/AddBulkAgents';
import AddAgent, { AgentDetails } from '../../Commponent/AddAgent';
import TextInput from '../../Commponent/TextInput';
import CustomSelectInput from '../../Commponent/SelectInput';
import edit from './../../assets/edit.png';
import CommonTableModal from '../../Commponent/CommonTableModal';
import calendar from './../../assets/calendar.png';
import downloadingRed from './../../assets/downloadingRed.png';
import { Search, ChevronUp, ChevronDown, Pencil } from 'lucide-react';
import EditUserModal from '../../Commponent/EditUserModal';
import { vehicleClasses } from '../../Utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { ErrorToast } from '../../Utils/toast';
import CommonTable from '../../Common/CommonTable';
import moment from 'moment';

// import AgentDetails from './../Commponent/AgentDetails';

//AGENT DISTRIBUTOR
const AgentDashboard = () => {
  const dispatch = useDispatch();
  const GetAgents = useSelector((state) => state.GetAgents.GetAgentsData);
  const GetAgentsNames = useSelector((state) => state.GetAgentsNames.GetAgentsNamesData);
  const GetDistributorAgentSummary = useSelector((state) => state.GetDistributorAgentSummary.GetDistributorAgentSummaryData);
  const [serialNumber, setSerialNumber] = useState('');
  const [selectedAgent, setSelectedAgent] = useState('');
  const [addBulkAgentsOpen, setAddBulkAgentsOpen] = useState(false);
  const [addAgentsOpen, setAddAgentsOpen] = useState(false);
  const [addMenuOpen, setAddMenuOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedAgentClick, setSelectedAgentClick] = useState(false);
  const [agentModalOpen, setAgentModalOpen] = useState(false);
  const [checkAgents, setCheckAgents] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [checkAgentsName, setCheckAgentsName] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [sortOrder, setSortOrder] = useState(null); // For status sorting
  const [assigningAgent, setAssigningAgent] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [agentData, setAgentData] = useState([]);
  const [agentDataNames, setAgentDataNames] = useState([]);
  const [selectedTimeFilter, setSelectedTimeFilter] = useState('thisYear');
  const [checkSummary, setCheckSummary] = useState(false);
  const [editAgent, setEditAgent] = useState(null);

  const columns = [
    { label: 'Serial Number', accessor: 'SerialNumber' },
    { label: 'Vehicle Class', accessor: 'VehicleClass' },
    { label: 'Status', accessor: 'Status' },
    { label: 'Purchase Date 1', accessor: 'PurchaseDate' },
    { label: 'Assigned to', accessor: 'AssignedTo' },
  ];



  const columns1 = [
    { label: 'Serial Number', accessor: 'SerialNumber' },
    { label: 'Vehicle Class', accessor: 'VehicleClass' },
    { label: 'Status', accessor: 'Status' },
    { label: 'Purchase Date 1', accessor: 'PurchaseDate' },
    { label: 'Assigned to', accessor: 'AssignedTo' },
    { label: 'Delivery Date', accessor: 'DeliveryDate' },
    { label: 'Delivery Status', accessor: 'DeliveryStatus' },
  ];

  const data = [
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC4",
      Status: "Unassigned",
      PurchaseDate: "3 March, 2025",
      AssignedTo: "5 March, 2025",
      vehicleClass: 6,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    },
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC5",
      Status: "Unassigned",
      PurchaseDate: "30 March, 2025",
      AssignedTo: "1 March, 2025",
      vehicleClass: 5,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    },
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC6",
      Status: "Unassigned",
      PurchaseDate: "1 March, 2025",
      AssignedTo: "30 March, 2025",
      vehicleClass: 4,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    }
  ]



  const totalPages = Math.ceil(tableData.length / itemsPerPage);
  const paginatedData = tableData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const topAgentsData = GetDistributorAgentSummary?.topAgents || [];
  const summaryData = topAgentsData
    ?.filter(agent => agent?.agentDetails) // Filter out agents with null agentDetails
    ?.map(agent => ({
      name: agent.agentDetails?.username || 'Unknown',
      percent: (agent.totalAssigned > 0) ? Math.min(100, parseFloat(agent.percentage) || 0) : 0,
      label: `Rank ${agent.rank}`,
      color: agent.rank === 1 ? '#22c55e' : agent.rank === 2 ? '#f59e0b' : '#ef4444' // color based on rank
    }));

  useEffect(() => {
    setCheckAgentsName(true)
    dispatch(ACTIONS.GetAgentsNamesAction());
  }, [])

  useEffect(() => {
    getData()
  }, [itemsPerPage, serialNumber, selectedAgent, currentPage])


  const handleAgentClick = (agentName) => {
    setSelectedAgentClick(agentName);
    setAgentModalOpen(true);
  };

  const toggleSortOrder = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const getData = () => {
    let params = {
      page: currentPage,
      limit: itemsPerPage,
      search: serialNumber,
      username: selectedAgent
    }
    setCheckAgents(true)
    dispatch(ACTIONS.GetAgentsAction(params));
  }



  useEffect(() => {
    if (checkAgents) {
      if (GetAgents?.status == 200 && GetAgents?.success) {
        setAgentData(GetAgents?.data.data);
      } else {
        ErrorToast(GetAgents?.message);
      }
      setCheckAgents(false)
      // setLoading(false);
    }
  }, [GetAgents])

  useEffect(() => {
    if (checkAgentsName) {
      if (GetAgentsNames?.status == 200 && GetAgentsNames?.success) {
        const uniqueAgents = Array.from(
          new Map(
            GetAgentsNames?.data?.map((agent) => [agent.username, agent])
          ).values()
        );

        setAgentDataNames(uniqueAgents);
      } else {
        ErrorToast(GetAgentsNames?.message);
      }
      setCheckAgentsName(false)
      // setLoading(false);
    }
  }, [GetAgentsNames])

  const handleFilterChange = (event) => {
    setSelectedTimeFilter(event.target.value);
    getSummaryData(event.target.value);
  };

  const getSummaryData = (timeFilter = selectedTimeFilter) => {
    const params = {
      thisYear: timeFilter === 'thisYear',
      thisMonth: timeFilter === 'thisMonth',
      LastMonth: timeFilter === 'LastMonth',
    };

    setCheckSummary(true);
    dispatch(ACTIONS.GetDistributorAgentSummaryAction(params));
  };

  useEffect(() => {
    // Load initial summary data
    getSummaryData();
  }, []);

  const refreshAll = () => {
    getData();
    getSummaryData();
  }

  useEffect(() => {
    if (checkSummary) {
      if (GetDistributorAgentSummary?.status === 200 && GetDistributorAgentSummary?.success) {
        // Data is automatically available in the selector
      } else if (GetDistributorAgentSummary?.message) {
        ErrorToast(GetDistributorAgentSummary?.message);
      }
      setCheckSummary(false);
    }
  }, [GetDistributorAgentSummary]);

  const AgentSummaryCard = ({ percent, name, label, color }) => {
    const radius = 30;
    const stroke = 6;
    const normalizedRadius = radius - stroke * 0.5;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (percent / 100) * circumference;

    return (
      <div className="flex items-center space-x-3 border rounded-xl px-4 py-3 shadow-sm bg-white">
        <svg height={radius * 2} width={radius * 2}>
          <circle
            stroke="#e5e7eb"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            stroke={color}
            fill="transparent"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference + ' ' + circumference}
            style={{ strokeDashoffset }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            transform={`rotate(-90 ${radius} ${radius})`}
          />
          <text
            x="50%"
            y="50%"
            dy="0.3em"
            textAnchor="middle"
            className="text-sm font-semibold"
          >
            {percent}%
          </text>
        </svg>
        <div>
          <h4 className="font-semibold text-gray-800">{name}</h4>
          <p className="text-sm text-gray-500">{label}</p>
        </div>
      </div>
    );
  };

  // const StatusBadge = ({ status }) => (
  //   <span className={`text-sm font-medium ${status === 'Active' ? 'text-green-600' : 'text-red-600'}`}>
  //     {status}
  //   </span>
  // );

  const StatusBadge = ({ status }) => {
    const base = "px-2 py-[2px] rounded-full text-xs font-medium flex items-center gap-1 justify-self-start";
    if (status) {

      return <span className={`${base} bg-green-100 text-green-900`}><span className="h-2 w-2 bg-green-500 rounded-full" />Active</span>;
    } else {

      return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Deactive</span>;
    }
    // if (status === "Deactive")
  };

  const tableColumns = [
    {
      label: "Agents",
      render: (agent) => (
        <button className="cursor-pointer  text-blue-600 font-medium" onClick={() => handleAgentClick(agent)}>{agent.username}</button>
      ),
    },
    { label: "Mobile Number", key: "mobileNo" },
    { label: "Email", render: (agent) => agent.email || "-" },
    {
      label: "Status",

      render: (agent, _) => <StatusBadge status={agent.isActive} />
    },
    {
      label: "Created At",
      key: "createdAt",
      render: (agent) => moment(agent.createdAt).format('DD MMMM, YYYY, hh:mm A')
    },

    { label: "Assigned FASTag", render: (agent) => agent.assigned || "0", },
    {
      label: "Activated FASTag",
      render: (agent) => agent.activated || "0",
      className: "[&>div]:!justify-start"
    },
    // Agents can ALWAYS activate FASTags — no activation toggle; edit covers email + view-transactions.
    {
      label: "Edit",
      tdClassName: "flex justify-end",
      render: (agent) => (
        <button
          onClick={() => setEditAgent(agent)}
          className="p-2 text-gray-500 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors"
          title="Edit agent"
        >
          <Pencil size={16} />
        </button>
      ),
    },
  ];


  const handleDownload = () => {
    //Download pdf of the slected class's pdf file

    const link = document.createElement('a');
    link.href = vehicleClasses[0].pdf;
    link.download = 'vehicle_class.pdf'; // Optional: file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  return (
    <div className="p-0 space-y-8">
      {/* Agents Summary */}
      <div className="">
        <div className="bg-[#FFFFFF] p-6 rounded-xl ">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-gray-800 text-[20px]">Agents Summary</h2>
            <select
              className="text-sm text-gray-600 bg-transparent outline-none"
              value={selectedTimeFilter}
              onChange={handleFilterChange}
            >
              <option value="thisMonth">This Month</option>
              <option value="LastMonth">Last Month</option>
              <option value="thisYear">This Year</option>
            </select>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 mb-[21px]">
            {(summaryData && summaryData.length > 0 ? summaryData : [
              { name: "N/A", percent: 0, label: "Rank 1", color: "#22C55E" },
              { name: "N/A", percent: 0, label: "Rank 2", color: "#F59E0B" },
              { name: "N/A", percent: 0, label: "Rank 3", color: "#EF4444" },
            ]).map((agent, i) => (
              <AgentSummaryCard
                key={i}
                percent={agent.percent}
                name={agent.name}
                label={agent.label}
                color={agent.color}
              />
            ))}
          </div>
        </div>

        {/* Search and Filter */}
        <div className="flex justify-between items-center mt-6 mb-6 md:gap-10 gap-6  relative lg:flex-row flex-col">
          <div className="flex !w-full items-center gap-2 md:flex-row flex-col">
            {/* Serial Number Input with Search Icon */}
            <div className="relative md:w-60 w-full">
              <TextInput
                name="serialNumber"
                placeholder="Mobile Number"
                value={serialNumber}
                onChange={(e) => setSerialNumber(e.target.value)}
                inputClass="pl-5 pr-3 py-[12.5px] text-sm"
              />
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                <Search className="w-4 h-4" />
              </div>
            </div>

            {/* Agent Dropdown using CustomSelectInput */}
            <div className="relative md:w-60 w-full ">
              <CustomSelectInput
                name="selectedAgent"
                label="" // No label for inline layout
                value={selectedAgent}
                placeholder="Select Agent"
                onChange={(e) => setSelectedAgent(e.target.value)}
                options={[
                  { name: "All Agents", value: "" },
                  ...agentDataNames.map((agent) => ({ name: agent.username, value: agent?.username })),
                ]}
                showSearch={true}
                inputClass="py-[12.5px] px-3 text-sm text-gray-500"
              />
            </div>
          </div>


          {/* Add Button with Dropdown */}
          <div className="relative">
            <Button
              label="Add +"
              onClick={() => setAddMenuOpen(!addMenuOpen)}
              roundedButton
              className="!bg-red-500 hover:!bg-red-600 !text-white rounded-full px-5 py-2"
            />
            {addMenuOpen && (
              <div className="absolute right-0 mt-2 w-36 bg-white border rounded shadow z-10">
                <button
                  onClick={() => { setAddMenuOpen(false); setAddAgentsOpen(true); }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm border border-gray-200"
                >
                  Add New Agent
                </button>
                <button
                  onClick={() => { setAddMenuOpen(false); setAddBulkAgentsOpen(true); }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
                >
                  Add Bulk Agents
                </button>
              </div>
            )}
          </div>
        </div>
        {/* Agent Table */}

        <CommonTable
          columns={tableColumns}
          data={agentData}
          emptyMessage="No Agents Found"
          setCurrentPage={setCurrentPage}
          setItemsPerPage={setItemsPerPage}
          currentPage={currentPage}
          isPagination={true}
          itemsPerPage={itemsPerPage}
          selectedDate={selectedDate}
          tableData={GetAgents?.data?.data}
          setSelectedDate={setSelectedDate}
          total={GetAgents?.data?.pagination?.total}
          totalPages={GetAgents?.data?.pagination?.totalPages}
          loading={checkAgents}
          hideDateAndDownload={true}
        />

      </div>

      <CommonTableModal
        open={isModalOpen}
        onClose={() => { setIsModalOpen(false); getData(); getSummaryData(); }}
        title={`${assigningAgent?.username} • Assigned: ${assigningAgent?.assigned || 0} • Activated: ${assigningAgent?.activated || 0} • Available: ${((assigningAgent?.assigned || 0) - (assigningAgent?.activated || 0))}`} // 👈 dynamic title
        columns={columns}
        columns1={columns1}
        tableData={data}
        tableData1={data}
        agentName={assigningAgent?.name}
        agentId={assigningAgent?._id}
      />


      {/* Modals */}
      <AddAgent modalOpen={addAgentsOpen} setModalOpen={setAddAgentsOpen} onClose={() => { setAddAgentsOpen(false); refreshAll() }} />
      {addBulkAgentsOpen && <AddBulkAgents
        sidebarTitle="Add Bulk Agent +"
        sampleFileName="upload_agent_sample"
        csvFileName="upload agent sample.csv"
        xlsxFileName="upload agent sample.xlsx"
        sampleFileUrls={{
          excel: "/upload agent sample.xlsx",
          csv: "/upload agent sample.csv"
        }}
        onClose={() => { setAddBulkAgentsOpen(false); refreshAll() }}
      />}
      {
        agentModalOpen &&
        <AgentDetails agent={selectedAgentClick} onBack={() => { setAgentModalOpen(false); setAddAgentsOpen(false); refreshAll() }} />
      }

      {/* Edit agent — email + view-transactions (agents always activate) */}
      <EditUserModal
        user={editAgent}
        roleLabel="agent"
        showEmail={true}
        onClose={() => setEditAgent(null)}
        onSaved={() => refreshAll()}
      />
    </div>
  );
};

export default AgentDashboard;